import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import '../csscomponent/Slidingimages.css';
import slider1 from '../assest/slider1.png';
import slider2 from '../assest/slider2.png';
import slider3 from '../assest/slider3.png';
import { BsArrowLeftCircleFill, BsArrowRightCircleFill } from 'react-icons/bs';

const AUTO_PLAY_MS = 4500;

const Slidingimages = () => {
  const slides = useMemo(
    () => [
      { image: slider1, title: 'High-converting landing experiences' },
      { image: slider2, title: 'Performance-first product interfaces' },
      { image: slider3, title: 'Brand visuals built for growth' },
    ],
    []
  );

  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(1);

  const nextSlide = useCallback(() => {
    setDirection(1);
    setCurrent((prev) => (prev + 1) % slides.length);
  }, [slides.length]);

  const prevSlide = useCallback(() => {
    setDirection(-1);
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  }, [slides.length]);

  useEffect(() => {
    const timer = setInterval(nextSlide, AUTO_PLAY_MS);
    return () => clearInterval(timer);
  }, [nextSlide]);

  const slideVariants = {
    enter: (dir) => ({ opacity: 0, x: dir > 0 ? 80 : -80, scale: 0.98 }),
    center: {
      opacity: 1,
      x: 0,
      scale: 1,
      transition: { duration: 0.55, ease: 'easeOut' },
    },
    exit: (dir) => ({
      opacity: 0,
      x: dir > 0 ? -80 : 80,
      scale: 0.98,
      transition: { duration: 0.38, ease: 'easeIn' },
    }),
  };

  const renderDots = () => (
    <>
      {slides.map((slide, index) => (
        <button
          key={slide.title}
          type="button"
          className={`snake-dot ${index === current ? 'active' : ''}`}
          onClick={() => {
            setDirection(index > current ? 1 : -1);
            setCurrent(index);
          }}
          aria-label={`Go to slide ${index + 1}`}
        >
          {index === current && (
            <motion.span
              key={current}
              className="snake-dot-progress"
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: AUTO_PLAY_MS / 1000, ease: 'linear' }}
            />
          )}
        </button>
      ))}
    </>
  );

  return (
    <section className="slider-modern" aria-label="Featured work slider">
      <div className="slider-shell">
        <button
          type="button"
          className="arrow arrow-left arrow-desktop"
          onClick={prevSlide}
          aria-label="Previous slide"
        >
          <BsArrowLeftCircleFill size={44} />
        </button>

        <div className="slider-frame">
          <AnimatePresence initial={false} mode="wait" custom={direction}>
            <motion.figure
              key={slides[current].image}
              className="slide-card"
              custom={direction}
              variants={slideVariants}
              initial="enter"
              animate="center"
              exit="exit"
            >
              <img src={slides[current].image} alt={slides[current].title} className="slide-image" />
              <figcaption>{slides[current].title}</figcaption>
            </motion.figure>
          </AnimatePresence>
        </div>

        <button
          type="button"
          className="arrow arrow-right arrow-desktop"
          onClick={nextSlide}
          aria-label="Next slide"
        >
          <BsArrowRightCircleFill size={44} />
        </button>
      </div>

      <div className="snake-status" aria-hidden="true">
        {renderDots()}
      </div>

      <div className="slider-mobile-controls" aria-hidden="true">
        <button type="button" className="arrow" onClick={prevSlide} aria-label="Previous slide">
          <BsArrowLeftCircleFill size={36} />
        </button>
        <div className="snake-status">
          {renderDots()}
        </div>
        <button type="button" className="arrow" onClick={nextSlide} aria-label="Next slide">
          <BsArrowRightCircleFill size={36} />
        </button>
      </div>
    </section>
  );
};

export default Slidingimages;
